'use client'

import * as Portal from '@radix-ui/react-portal'
import React, { useEffect } from 'react'

import { DownloadPanel } from './download-panel'
import { useDownloadPanelContext } from './download-panel.context'

const DownloadPanelWrapper: React.FC = () => {
  const { showDownloadSlidePanel, toggleDownloadSlidePanel } =
    useDownloadPanelContext()
  const mainContainer = React.useRef<HTMLElement | null>(null)

  useEffect(() => {
    mainContainer.current = document.querySelector('main')
  }, [])

  useEffect(() => {
    mainContainer.current = document.querySelector('main')
  }, [])

  return (
    <>
      {showDownloadSlidePanel && mainContainer.current && (
        <Portal.Root container={mainContainer.current} asChild>
          <DownloadPanel
            toggleDownloadPanel={toggleDownloadSlidePanel}
            show={showDownloadSlidePanel}
          />
        </Portal.Root>
      )}
    </>
  )
}

export default DownloadPanelWrapper
